
const statusRegister = {
	NOT_REGISER_YET: "null",
	REJECT_BY_SP: "-3",
	REJECT_BY_SA: "-2",
	WAIT_SA: "-1",
	WAIT_SP: "0",
	WAIT_DOC: "1",
	SUCCESS: "2"
}

const ListTitleName = [
	{ code: 1 , nameTitle: 'นาย' , nameTitleEng: 'MR'},
	{ code: 2 , nameTitle: 'นาง' , nameTitleEng: 'MRS'},
	{ code: 3 , nameTitle: 'นางสาว' , nameTitleEng: 'MISS'},
	{ code: 7 , nameTitle: 'ว่าที่ ร.ต. หญิง' , nameTitleEng: 'MISS'},
	{ code: 8 , nameTitle: 'พลฯหญิง' , nameTitleEng: 'MISS'},
	{ code: 9 , nameTitle: 'ว่าที่ ร.ต.' , nameTitleEng: 'MR'},
	{ code: 4 , nameTitle: 'บจก.' , nameTitleEng: 'MR'},
	{ code: 5 , nameTitle: 'บริษัท' , nameTitleEng: 'MR'},
	{ code: 6 , nameTitle: 'ห้างหุ้นส่วนจำกัด' , nameTitleEng: 'MR'},
  ]
export default {
	statusRegister ,
	ListTitleName
}